export interface Bono {
  numero: string
  titulo: string
  descripcion: string
  imagen: string
}

export const bonos: Bono[] = [
  {
    numero: '01',
    titulo: '100 actividades ESI rápidas para el aula',
    descripcion:
      '100 actividades listas para utilizar, organizadas según objetivos y duración: propuestas de 10, 45 o 60 minutos. Incluye dinámicas para iniciar temas, romper el hielo, generar debates, trabajar en grupos, recuperar conocimientos previos, reflexionar y cerrar clases.',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/f5facb8a-723b-4245-88a6-1b8e87a15427.jpg',
  },
  {
    numero: '02',
    titulo: '100 casos y situaciones para debatir',
    descripcion:
      '100 situaciones cercanas a la realidad adolescente sobre vínculos, consentimiento, bullying, redes sociales, violencia, discriminación, presión de pares, diversidad, salud mental y ciudadanía digital. Cada caso incluye preguntas disparadoras para analizar, debatir, argumentar y buscar soluciones.',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/f7a26cd9-b203-48a0-a834-db4acf5cca75.jpg',
  },
  {
    numero: '03',
    titulo: 'Kit de jornadas ESI listas para implementar',
    descripcion:
      'Un conjunto de propuestas estructuradas para organizar jornadas ESI sin tener que diseñar todo desde cero. Especialmente útil para jornadas, talleres y actividades institucionales.',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/48a1ffc2-0d02-4c49-8675-538d83b564b9.jpg',
  },
  {
    numero: '04',
    titulo: '100 actividades de ciudadanía digital',
    descripcion:
      '100 propuestas para trabajar identidad digital, privacidad, huella digital, exposición, cyberbullying, grooming, fake news, inteligencia artificial, influencers, presión social, imagen corporal y uso responsable de la tecnología.',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/18268c98-3ad9-470c-abd8-23d23f362c28.jpg',
  },
  {
    numero: '05',
    titulo: 'Guía docente para abordar temas sensibles',
    descripcion:
      'Orientaciones para preparar clases, establecer acuerdos de convivencia, formular preguntas, moderar debates y acompañar conversaciones sobre violencia, discriminación, sexualidad y salud mental. Te ayuda a sentirte mejor preparado: no reemplaza la intervención de profesionales ni los protocolos institucionales cuando corresponda.',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/1532d023-0513-4505-9f42-b9ff2aeeb6bd.jpg',
  },
]
